/**
 * Page-level header actions. A page registers its action buttons (e.g. "Add", "Request
 * Leave") via useHeaderActions(); AppLayout renders them on the right of the top header.
 * Title lives in the header too — pages no longer render their own <h1>.
 */
import { createContext, useContext, useEffect, type Dispatch, type ReactNode, type SetStateAction } from 'react'

export const PageActionsContext = createContext<Dispatch<SetStateAction<ReactNode>> | null>(null)

/**
 * Register header actions for the current page. Pass deps that affect the node
 * (e.g. [locale], plus any state used by the buttons) so it re-renders correctly.
 */
export function useHeaderActions(node: ReactNode, deps: unknown[]) {
  const setActions = useContext(PageActionsContext)
  useEffect(() => {
    setActions?.(node)
    return () => setActions?.(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
